///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.short_dated = abcsetup.short_dated || {};
abcsetup.short_dated.responses = abcsetup.short_dated.responses || {};
abcsetup.short_dated.responses.show = abcsetup.short_dated.responses.show || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////

abcsetup.short_dated.responses.show = {
    /**
     * _jquery.fieldLib
     *      Fields have been init - this is the callback
     */
    fieldsInit: function () {
        // TODO: split aparent the common lib between opportunities + responses
        abcsetup.short_dated_opportunity.common.bindFields();
    },
}
